import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { shouldShowAppointmentBookingOnPage } from '../../Components/AppointmentBooking/appointmentBooking.helpers';
import { shouldShowSubmissionBlockPage } from '../../Helpers/submission';

const useShouldShowNavigation = () => {
  const { pagesWithLoaderComponent } = useSelector((store) => store.paging);
  const { currentPage } = useSelector((store) => store.navigation);
  const components = useSelector((store) => store.components);
  const { formId } = useSelector((store) => store.formConfig);
  const { submissionBlocks } = useSelector((store) => store.submission);

  const isLoaderPage = pagesWithLoaderComponent.includes(currentPage);
  const isAppointmentBookingOnThisPage = useMemo(() => {
    return shouldShowAppointmentBookingOnPage({
      components,
      formId,
      pageNumber: currentPage,
    });
  }, [components, formId, currentPage]);

  const shouldShowNavigation =
    shouldShowSubmissionBlockPage(currentPage, submissionBlocks) ||
    (!isAppointmentBookingOnThisPage &&
      (!currentPage || !pagesWithLoaderComponent || !isLoaderPage));

  return { shouldShowNavigation };
};

export default useShouldShowNavigation;
